import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import toast from "react-hot-toast";
import styles from "./Footer.module.css";
import { BRAND } from "../data/content";
import { db } from "../firebase";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)) {
      toast.error("Please enter a valid email");
      return;
    }
    try {
      setBusy(true);
      await addDoc(collection(db, "subscribers"), {
        email,
        createdAt: serverTimestamp(),
        source: "footer",
      });
      toast.success("Subscribed! We’ll be in touch.");
      setEmail("");
    } catch (err) {
      console.error(err);
      toast.error("Couldn’t subscribe right now. Try again?");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.grid}>
          <div>
            <Link to="/" className={styles.brand}>
              <span className={styles.brandMark}>P</span>
              {BRAND.name}
            </Link>
            <p className={styles.about}>{BRAND.mission}</p>
          </div>

          <div className={styles.col}>
            <h4 className={styles.colTitle}>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Our Work</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className={styles.col}>
            <h4 className={styles.colTitle}>Build With Us</h4>
            <ul>
              <li><Link to="/contact?type=portfolio">Student Portfolio</Link></li>
              <li><Link to="/contact?type=business">Business Website</Link></li>
              <li><Link to="/contact?type=ecommerce">E-commerce Store</Link></li>
              <li><Link to="/contact?type=ai">AI-powered Site</Link></li>
              <li><Link to="/contact?type=saas">SaaS / MVP</Link></li>
            </ul>
          </div>

          <div className={styles.col}>
            <h4 className={styles.colTitle}>Get in Touch</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <a href={`mailto:${BRAND.email}`} className={styles.contactItem}>
                <FiMail size={16} /> {BRAND.email}
              </a>
              <a href={`tel:${BRAND.phone}`} className={styles.contactItem}>
                <FiPhone size={16} /> {BRAND.phone}
              </a>
              <span className={styles.contactItem}>
                <FiMapPin size={16} /> {BRAND.city}
              </span>
            </div>

            <form className={styles.subForm} onSubmit={subscribe}>
              <input
                type="email"
                className={styles.subInput}
                placeholder="Your email for updates"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Email"
              />
              <button className={styles.subBtn} disabled={busy}>
                {busy ? "…" : "Join"}
              </button>
            </form>
          </div>
        </div>

        <div className={styles.bottom}>
          <span>© {new Date().getFullYear()} {BRAND.name}. Crafted with care in India.</span>
          <div className={styles.bottomLinks}>
            <button className={styles.linkBtn} onClick={() => {}}>Privacy</button>
            <button className={styles.linkBtn} onClick={() => {}}>Terms</button>
            <button className={styles.linkBtn} onClick={() => {}}>Refund</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
